import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { getReactivatedContext } from "tsi-common-react/src/utils/environment";
import { CAPTION_MEDIUM_CLASS_NAME } from "tsi-common-react/src/utils/typography";
import { t } from "ttag";

import { Context, type PromiseBlock as PromiseBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

const getStaticURL = (staticURL: string, path: string): string =>
    `${staticURL}${path}`;

export const CocoonPromiseBlock = (
    props: Immutable<{ value: PromiseBlockValue }>,
): React.JSX.Element => {
    const context = React.useContext(Context) || getReactivatedContext();
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const staticURL = context?.STATIC_URL ?? "/static/";
    const value = props.value;

    return (
        <section
            className={concatClassNames([
                "promise",
                styles.promiseC,
                "stitch-bg",
                getGlobalSpacingClasses(value.spacing),
            ])}
        >
            <div className="main-container">
                <div>
                    <img
                        src={getStaticURL(
                            staticURL,
                            "img/global/guarantee/free-returns-icon-white2x.png",
                        )}
                        alt=""
                        loading="lazy"
                        decoding="async"
                    />
                </div>
                <div className="content">
                    <div
                        className={concatClassNames([
                            CAPTION_MEDIUM_CLASS_NAME,
                            "caption-medium",
                        ])}
                    >
                        {value.promise_line ||
                            "100 Night Trial\u00a0\u00b7\u00a0Free Shipping\u00a0\u00b7\u00a010 year mattress warranty"}
                    </div>
                    <h2>{value.title}</h2>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: value.paragraph ?? "",
                        }}
                    />
                    <a href={value.link?.url ?? ""}>{t`Learn More`}</a>
                </div>
            </div>
        </section>
    );
};
